module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_modernmind-3ee49afee532699b94025b36d030d362.svg";